import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import { History } from 'history'
import React from 'react'

import { useCatiContactsPreferences } from '@/app/module/cati/hooks/use-cati-contacts-preferences'
import { getOrgSubs as getOrgSubsAction, navigateOrgSubs, setCATISubsPageSize } from '@/app/module/cati/store/actions'
import { OrgSubscriptionTableType } from '@/app/module/cati/types'
import { Column } from '@/config/types'

import MobileSubs from './mobile-subs'
import Subs from './subs'

type Props = {
  headers: Column[]
  history: History
  loading: boolean
  orgId: number
  page: number
  pageSearchTerm?: string | null
  searchTerm: string | null
  size: number
  timezone: string
  token: string
  total: number
  userId: number
  values: OrgSubscriptionTableType[]
  getOrgSubs: typeof getOrgSubsAction
  navigate: typeof navigateOrgSubs
  setPageSize: typeof setCATISubsPageSize
}

const ResponsiveSubs: React.FC<Props> = (props) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const { callContactMode, isSaving, setCallContactMode } = useCatiContactsPreferences()

  const preferenceProps = {
    callContactMode,
    isCallContactModeSaving: isSaving,
    onCallContactModeChange: setCallContactMode,
  }

  return isMobile ? <MobileSubs {...props} {...preferenceProps} /> : <Subs {...props} {...preferenceProps} />
}

export default ResponsiveSubs
